import { useCallback, useRef, useState, type DetailedHTMLProps, type ImgHTMLAttributes } from 'react';

type Props = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  fallback?: string;
};

const Image = (props: Props) => {
  const [src, setSrc] = useState(props.src);
  const numRetries = useRef(0);

  const onError = useCallback(() => {
    if (numRetries.current > 2) {
      return;
    }

    // do not recursively call the onError handler because of a failure of the fallback
    numRetries.current++;
    setSrc(props.fallback);
  }, [props.fallback]);

  // some browsers can force a page refresh if the image element is passed
  // an empty string as the src prop - if there is no src prop passed, do not pass in src at all
  // and do not fall back to an empty string
  return <img {...props} src={src ? src : undefined} onError={onError} />;
};

export default Image;
